<div class="p-dialog-header px-spacing-xl py-spacing-md justify-content-end">
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<iframe
  #iframe
  title="Messages"
  width="100%"
  height="70vh"
  [src]="adroitIframeUrl()"></iframe>
